import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';

/**
 * 初期設定サポートページ用共通ミックスインオブジェクト
 */
export default {
    /**
     * データ群
     */
    data() {
        return {
            // 初期設定ページ一覧(trueで現在のページ)
            pages: {
                store: false,
                info: false,
                payment: false,
                delivery: false,
                mail: false,
                confirm: false,
                finish: false,
            },
            // ページ上のデータ
            setup_data: {},
        };
    },
    /**
     * 算出プロパティ
     */
    computed: {
        // 戻るボタンを押した時のリンク先
        prevPage: function () {
            let path = '/menu';
            for (let page of Object.keys(this.pages)) {
                if (this.pages[page]) {
                    return path;
                }
                path = '/setup/' + page;
            }
        },
        // 保存して次のページのリンク先
        nextPage: function () {
            let path = '';
            for (let page of Object.keys(this.pages).reverse()) {
                if (this.pages[page]) {
                    return path;
                }
                path = '/setup/' + page;
            }
        }
    },
    /**
     * ミックスインオブジェクト
     */
    mixins: [
        commonMixin,
        flashMessageMixin
    ],
    /**
     * インスタンス生成時に実行される処理
     */
    created() {
        // ブラウザバック、進むが発生したらリロード
        window.addEventListener('popstate', function () {
            console.log('popstate');
            window.location.reload(true);
        });
        this.setPage();
        this.setData();
    },
    /**
     * 各種メソッド
     */
    methods: {
        // 現在ページをtrueにする
        setPage() {
            const page = location.pathname.replace(/(.*\/)(.*?$)/, '$2');
            this.pages[page] = true;
        },
        // JSで使う用にレンダリングされたJSON文字列をデータとして取得
        setData() {
            const data = document.querySelector('[data-roll="setup-data"]');
            if (data) {
                this.setup_data = JSON.parse(data.innerHTML);
            }
        },
        // 指定URLへ遷移(popstateを検知させる為、pushStateでURLを変更したあとリロード)
        locationHref(url) {
            window.history.pushState(null, null, url);
            window.location.reload(true);
            window.scroll(0, 0);
            this.$_loading();
        },
        // 前のページへ戻る
        prev() {
            this.locationHref(this.prevPage);
        },
        // ページ上のデータを保存して次へ進む
        async save (event) {
            // formタグで挟んでいてHTML5のバリデーションエラーの場合はそのままフォーム送信する
            if (typeof event?.target?.form !== 'undefined' && event?.target?.form !== null && !event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await axios.post(location.pathname + '/save', {
                    _method: 'PUT',
                    setup_data: this.setup_data
                });
                if (response.data.status === 'OK') {
                    // エラーメッセージを空にする
                    message = '';
                    // 次ページへ進む
                    this.locationHref(this.nextPage);
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            if (message) {
                this.$_unloading();
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
            }
        }
    }
};
